import { Baby, Dog } from "lucide-react";

// Kids & Pets trust callout — reused across pest pages, DIY, and guides.
export default function KidsPetsBadge({ body }) {
  return (
    <div
      className="relative overflow-hidden rounded-3xl border border-teal/25 bg-teal/5 p-6 sm:p-8"
      data-testid="kids-pets-badge"
    >
      <div className="flex items-center gap-3 mb-4">
        <div className="flex -space-x-1">
          <div className="w-10 h-10 rounded-full bg-teal/15 flex items-center justify-center">
            <Baby className="w-5 h-5 text-teal" />
          </div>
          <div className="w-10 h-10 rounded-full bg-teal/15 flex items-center justify-center ring-2 ring-cream">
            <Dog className="w-5 h-5 text-teal" />
          </div>
        </div>
        <div>
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-teal">Trust theme</span>
          <h3 className="font-serif text-xl font-bold text-forest-950">Kids & Pets</h3>
        </div>
      </div>
      <p className="text-[15px] text-forest-950/80 leading-relaxed">{body}</p>
    </div>
  );
}
